import { registerEnumSet } from '@if/mui'
import { EMetro2AccountStatus, getEMetro2AccountStatusList } from '@src/types/constants'

export const EMetro2AccountStatusSet = Object.fromEntries(
  getEMetro2AccountStatusList().map((status) => [EMetro2AccountStatus[status], String(status)]),
) as { [K in keyof typeof EMetro2AccountStatus]: `${(typeof EMetro2AccountStatus)[K]}` }

export type EMetro2AccountStatusValue = (typeof EMetro2AccountStatusSet)[keyof typeof EMetro2AccountStatusSet]

export const toMetro2AccountStatusValue = (status: EMetro2AccountStatus): EMetro2AccountStatusValue =>
  String(status) as EMetro2AccountStatusValue

registerEnumSet(
  EMetro2AccountStatusSet,
  {
    0: { labelKey: 'loan.payment.creditReportCard.statusByMissingPayments.accountStatus0', color: 'success' },
    1: { labelKey: 'loan.payment.creditReportCard.statusByMissingPayments.accountStatus1' },
    2: { labelKey: 'loan.payment.creditReportCard.statusByMissingPayments.accountStatus2' },
    3: { labelKey: 'loan.payment.creditReportCard.statusByMissingPayments.accountStatus3' },
    4: { labelKey: 'loan.payment.creditReportCard.statusByMissingPayments.accountStatus4' },
    5: { labelKey: 'loan.payment.creditReportCard.statusByMissingPayments.accountStatus5' },
    6: { labelKey: 'loan.payment.creditReportCard.statusByMissingPayments.accountStatus6' },
  },
  {
    grades: [
      EMetro2AccountStatusSet.ThirtyDays,
      EMetro2AccountStatusSet.SixtyDays,
      EMetro2AccountStatusSet.NinetyDays,
      EMetro2AccountStatusSet.OneTwentyDays,
      EMetro2AccountStatusSet.OneFiftyDays,
      EMetro2AccountStatusSet.OneEightyDays,
    ],
  },
)
